export default {
      id: "icon-star-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }